/** Certificate — document knowledge definition. Pure data. */
export default {
  id: 'certificate',
  name: 'Certificate',
  description: 'A formal document recognizing an achievement, completion, or award.',
  purpose: 'Recognition & Award',
  recommendedSizes: [{ name: 'A4 Landscape', width: 3508, height: 2480, unit: 'px' }],
  supportedOrientations: ['landscape', 'portrait'],
  supportsMultiplePages: false,
  supportsBleed: true,
  supportsImages: false,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: false,
  supportsPricing: false,
  supportsCTA: false,
  supportsOffers: false,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Title', 'Recipient', 'Description', 'Signature', 'Seal'],
};
